import { Box, Text, Wrap } from '@chakra-ui/react';
import { MenuModel } from 'lib/api/model';
import SubMenuItem from './SubMenuItem';

interface ISubMenuListProps {
  title: string;
  menuList: MenuModel[];
  menuId: number[];
  selectMenu: (id: number) => void;
  infoDialog: (
    id: number,
    title: string,
    image: string,
    ratio: number,
    description: string
  ) => void;
}

function SubMenuList(props: ISubMenuListProps) {
  return (
    <Box mt={'20px'}>
      <Text fontSize={'14px'} fontWeight="semibold">
        {props.title}
      </Text>
      <Wrap spacing={'9px'} overflow="visible" mt={'10px'}>
        {props.menuList.map((menu, index) => (
          <SubMenuItem
            key={index}
            item={menu}
            idxMenu={props.menuId}
            onPress={props.selectMenu}
            onPressInfo={props.infoDialog}
          />
        ))}
      </Wrap>
    </Box>
  );
}
export default SubMenuList;
